export default __webpack_public_path__ + "static/hightlight-product-bg-mobile-0d40d5af907621714101359987c1c6a8.jpg";